import { Heart, Sparkles } from "lucide-react";
import { DoodleField } from "@/components/landing/Doodles";
import { scrollToId } from "@/components/landing/Header";

export const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="relative overflow-hidden bg-yellow-300 pt-12 pb-24 sm:pt-16"
  >
    <DoodleField />
    <div className="max-w-6xl mx-auto px-6 relative z-10 text-center">
      <h1 className="font-display font-bold text-pink-500 leading-[0.95] text-5xl sm:text-7xl lg:text-8xl drop-shadow-[2px_2px_0_rgba(255,255,255,0.6)]">
        WonderStarzLV
      </h1>
      <div className="mt-3 flex justify-center flex-wrap gap-2 text-4xl sm:text-6xl font-display font-bold">
        <span className="text-teal-500">DAY</span>
        <span className="text-pink-500">CAMP!</span>
      </div>

      <div className="mt-6 inline-block bg-emerald-700 text-yellow-50 font-display font-semibold text-lg sm:text-2xl px-6 py-3 rounded-2xl shadow-pop rotate-[-1deg]">
        Where parents find relief and kids find wonder{" "}
        <Heart className="inline w-5 h-5 text-pink-400" fill="#f472b6" />
      </div>

      <p className="mt-7 max-w-2xl mx-auto text-emerald-950 font-medium text-lg sm:text-xl leading-relaxed">
        A fun and safe day camp experience where kids explore, create, learn, and make new
        friends through hands-on activities, STEM projects, arts and crafts, and creative play.
      </p>

      <button
        data-testid="hero-enroll-btn"
        onClick={() => scrollToId("enroll")}
        className="mt-9 inline-flex items-center gap-2 bg-pink-500 text-white font-display font-bold text-xl sm:text-2xl px-12 py-5 rounded-full shadow-pop hover:bg-pink-600 hover:scale-105 transition-all"
      >
        <Sparkles className="w-6 h-6" fill="white" /> Enroll Today!
      </button>
    </div>

    {/* wavy bottom edge */}
    <svg
      className="absolute -bottom-1 left-0 w-full text-yellow-50"
      viewBox="0 0 1440 80"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M0,40 C180,80 360,0 540,30 C720,60 900,80 1080,50 C1260,20 1380,50 1440,40 L1440,80 L0,80 Z"
      />
    </svg>
  </section>
);
